<template>
  <div id="Dashboard">
    <a-page-header
      title="看板中心"
      style="padding-left: 0; margin-bottom: 10px; border-bottom: 1px solid rgb(235, 237, 240)"
    />
    <div class="header">
      <a-form layout="inline">
        <a-form-item label="名称：">
          <a-input v-model="reportName" placeholder="请输入" style="width: 200px" />
        </a-form-item>
        <a-form-item label="标签：">
          <a-select
            :getPopupContainer="
              (triggerNode) => {
                return triggerNode.parentNode || document.body;
              }
            "
            placeholder="请选择"
            option-filter-prop="children"
            style="width: 200px"
            :maxTagCount="1"
            :maxTagTextLength="4"
            :filter-option="filterOption"
            mode="multiple"
            v-model.trim="lableIdList"
          >
            <a-select-option v-for="(v, i) in labelSelect" :key="i" :value="v.labelId"
              >{{ v.labelName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="分类：">
          <a-select
            :getPopupContainer="
              (triggerNode) => {
                return triggerNode.parentNode || document.body;
              }
            "
            placeholder="请选择"
            option-filter-prop="children"
            style="width: 200px"
            :maxTagCount="1"
            :maxTagTextLength="4"
            :filter-option="filterOption"
            mode="multiple"
            v-model.trim="classifyIdList"
          >
            <a-select-option v-for="(v, i) in classTypeList" :key="i" :value="v.id"
              >{{ v.classifyName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <span class="btnClass">
          <a-button type="primary" @click="search" style="margin-top: 3px">
            <a-icon type="search" />
            查询
          </a-button>
          <a-button style="margin-left: 15px" @click="resetSearchForm"> 重置 </a-button>
        </span>
      </a-form>
    </div>
    <div class="middle" v-if="dashboardList.length > 0">
      <div style="width: 25%" v-for="(v, i) in dashboardList" :key="i">
        <div class="row">
          <div class="modular">
            <img @click="openUrl(v)" :src="v.thumbnailUrl" alt="" />
          </div>
          <span class="report-name" @click="openUrl(v)">{{ v.reportName }}</span>
        </div>
      </div>
    </div>
    <div v-else class="middles">
      <div>
        <svg
          t="1636523979871"
          class="icon"
          viewBox="0 0 1567 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="2057"
          width="150"
          height="150"
        >
          <path
            d="M156.662278 699.758173h21.097186A10.444152 10.444152 0 0 1 187.994733 710.202325c0 5.765172-4.490985 10.444152-10.235269 10.444152H156.662278v21.097186A10.444152 10.444152 0 0 1 146.218126 751.978932a10.277045 10.277045 0 0 1-10.444152-10.235269V720.646477H114.676787A10.444152 10.444152 0 0 1 104.441518 710.202325c0-5.765172 4.490985-10.444152 10.235269-10.444152H135.773974v-21.097187A10.444152 10.444152 0 0 1 146.218126 668.425717c5.765172 0 10.444152 4.490985 10.444152 10.235269v21.097187z m1378.628042-83.553215v-21.097186A10.277045 10.277045 0 0 0 1524.846168 584.872503a10.444152 10.444152 0 0 0-10.444152 10.235269v21.097186h-21.097186a10.277045 10.277045 0 0 0-10.235269 10.444152c0 5.598065 4.595427 10.444152 10.235269 10.444152h21.097186v21.097187c0 5.744284 4.67898 10.235269 10.444152 10.235268a10.444152 10.444152 0 0 0 10.444152-10.235268V637.093262h21.097187c5.744284 0 10.235269-4.67898 10.235268-10.444152a10.444152 10.444152 0 0 0-10.235268-10.444152H1535.29032zM776.460024 960.861969H250.596979A20.80475 20.80475 0 0 1 229.77134 939.973665c0-11.530344 9.462402-20.888304 20.825639-20.888303h94.728457A83.010119 83.010119 0 0 1 334.212859 877.413196v-605.96969A83.49055 83.49055 0 0 1 417.849627 187.994733H480.430984V167.001988A83.49055 83.49055 0 0 1 564.067752 83.553215h501.152182A83.448773 83.448773 0 0 1 1148.856702 167.001988v605.969689c0 15.185797-4.052331 29.410732-11.133466 41.672166h115.554096c11.551232 0 20.909192 9.274407 20.909192 20.888304 0 11.530344-9.295295 20.888304-20.888304 20.888304H1002.638576v20.992745c0 15.185797-4.052331 29.410732-11.133466 41.672166h11.196131c11.488567 0 20.825639 9.274407 20.825639 20.888303 0 11.530344-9.462402 20.888304-20.825639 20.888304h-109.893365c9.545955 16.000441 7.478013 36.972297-6.41271 50.863019a41.672166 41.672166 0 0 1-59.072122 0L776.460024 960.861969z m76.367638-41.776607h66.424806c22.977134 0 41.609501-18.59059 41.609501-41.881049V270.461756c0-22.559368-18.047494-40.690416-40.314426-40.690416H416.303892c-22.266932 0-40.314426 18.214601-40.314426 40.690416v606.742557c0 23.123352 18.799473 41.881049 41.588613 41.881049h317.084449l-10.736588-10.757477a41.693054 41.693054 0 0 1-10.861918-40.377091l-19.718558-19.739447A146.259902 146.259902 0 0 1 502.363703 627.693525a146.218126 146.218126 0 0 1 220.517822 190.981761l19.739447 19.739447a41.630389 41.630389 0 0 1 40.377091 10.841029L852.827662 919.085362zM1002.638576 814.643843h62.852906A41.797496 41.797496 0 0 0 1107.080095 772.867236V167.106429c0-23.14424-18.632367-41.776607-41.588613-41.776607H563.775316A41.797496 41.797496 0 0 0 522.207592 167.106429v20.888304h396.794216A83.448773 83.448773 0 0 1 1002.638576 271.443506V814.643843zM266.325872 46.998683h31.123572c8.773088 0 15.875111 6.955805 15.875111 15.666228 0 8.647758-7.102023 15.666228-15.875111 15.666228h-31.123572v31.123572c0 8.773088-6.955805 15.875111-15.666228 15.875111a15.770669 15.770669 0 0 1-15.666228-15.875111V78.331139H203.869844A15.728893 15.728893 0 0 1 187.994733 62.664911c0-8.647758 7.102023-15.666228 15.875111-15.666228h31.123572V15.875111c0-8.773088 6.955805-15.875111 15.666228-15.875111 8.647758 0 15.666228 7.102023 15.666228 15.875111v31.123572zM20.888304 939.973665c0-11.530344 9.462402-20.888304 20.825638-20.888303h125.455152c11.488567 0 20.825639 9.274407 20.825639 20.888303 0 11.530344-9.462402 20.888304-20.825639 20.888304H41.713942A20.80475 20.80475 0 0 1 20.888304 939.973665z m658.733544-135.021995a104.441518 104.441518 0 1 0-147.722083-147.722083 104.441518 104.441518 0 0 0 147.722083 147.722083zM459.542681 313.324555a20.888304 20.888304 0 0 1 20.867415-20.888304H710.202325a20.888304 20.888304 0 1 1 0 41.776608H480.430984A20.825639 20.825639 0 0 1 459.542681 313.324555z m0 104.441518c0-11.530344 9.295295-20.888304 20.742085-20.888303h334.505295c11.44679 0 20.742086 9.274407 20.742086 20.888303 0 11.530344-9.295295 20.888304-20.742086 20.888304H480.284766A20.762974 20.762974 0 0 1 459.542681 417.766073z m0 104.441519c0-11.530344 9.316183-20.888304 20.846527-20.888304h146.301679c11.509455 0 20.846527 9.274407 20.846527 20.888304 0 11.530344-9.316183 20.888304-20.846527 20.888303h-146.301679A20.80475 20.80475 0 0 1 459.542681 522.207592zM62.664911 396.87777a62.664911 62.664911 0 1 1 0-125.329822 62.664911 62.664911 0 0 1 0 125.329822z m0-31.332456a31.332456 31.332456 0 1 0 0-62.664911 31.332456 31.332456 0 0 0 0 62.664911zM1357.739739 271.547948a62.664911 62.664911 0 1 1 0-125.329822 62.664911 62.664911 0 0 1 0 125.329822z m0-31.332456a31.332456 31.332456 0 1 0 0-62.664911 31.332456 31.332456 0 0 0 0 62.664911z"
            fill="#bfbfbf"
            p-id="2058"
          ></path>
        </svg>
        <p>暂无报告</p>
      </div>
    </div>
    <div class="fotter" v-if="total > 16">
      <a-pagination
        show-size-changer
        :show-total="(total) => `共 ${total} 条`"
        show-quick-jumper
        :defaultCurrent="pageNum"
        :defaultPageSize="pageSize"
        :total="total"
        :current="pageNum"
        :pageSize="pageSize"
        :showSizeChanger="true"
        :pageSizeOptions="['8', '16', '24', '48']"
        @change="onChangePage"
        @showSizeChange="onShowSizeChange"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { userInfo } from "@/utils/userInfo";
import { currentProjectAddress } from "@/config";
import Base64 from "@/utils/base64";
export default {
  data() {
    return {
      pageSize: 16,
      pageNum: 1,
      classifyIdList: [], //分类
      reportName: "", //名称
      lableIdList: [], //标签
    };
  },
  created() {
    this.getClassSelectList({type:1});
    this.getLabelSelect(); //获取标签下拉值
    this.getData();
  },
  mounted() {},
  computed: {
    ...mapState({
      dashboardList: (state) => state.dashboard.reportList,
      total: (state) => state.dashboard.reportTotal,
      classTypeList: (state) => state.dashboard.classTypeList,
      labelSelect: (state) => state.dashboard.labelSelect,
    }),
  },
  methods: {
    ...mapActions({
      getDashboard: "dashboard/getKanbanList",
      getSelectList: "dashboard/getSelectList",
      getLabelSelect: "dashboard/getLabelSelect",
      checkLogAddLog: "dashboard/checkLogAddLog",
      getClassSelectList: "dashboard/getClassSelectList",
    }),

    getData() {
      this.getDashboard({
        reportName: this.reportName,
        lableIdList: this.lableIdList,
        classifyIdList: this.classifyIdList,
        page: this.pageNum,
        size: this.pageSize,
      });
    },
    //搜索
    async search() {
      this.pageNum = 1;
      this.pageSize = 16;
      this.getData();
    },
    //重置
    resetSearchForm() {
      this.pageSize = 16;
      this.pageNum = 1;
      this.classifyIdList = [];
      this.reportName = "";
      this.lableIdList = [];
      this.getData();
    },

    //模糊查询
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    //判断是否为移动端
    // _isMobile() {
    //   let flag = navigator.userAgent.match(
    //     /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    //   );
    //   return flag;
    // },
    // 判断当前设备类型 并打开url
    openUrl(value) {
      this.$sensors.track("PlatformDetail", {
        ...userInfo(),
        product_name: value.reportName,
        ies_product_id: value.id,
        tab_name: "看板中心",
      });
      this.checkLogAddLog({
        module: "看板中心",
        reportName: value.reportName,
      });
      //0 PC  1 H5  2判断当前设备
      const openUrl = Base64.linkEncode(value.reportUrl, value.id, value.reportType);
      window.open(`${currentProjectAddress}templates?openUrl=${openUrl}&reportName=${value.reportName}`);
      // 不要删除 为了以后修改此需求方便调试
      // window.open(`http://localhost:8080/templates?openUrl=${openUrl}&reportName=${value.reportName}`);
    },
    //分页
    onShowSizeChange(pageNum, pageSize) {
      this.pageNum = pageNum;
      this.pageSize = pageSize;
      this.getData();
    },
    onChangePage(pageNum, pageSize) {
      this.pageNum = pageNum;
      this.pageSize = pageSize;
      this.getData();
    },
  },
};
</script>

<style scoped>
.header {
  display: flex;
  height: 50px;
  line-height: 50px;
  padding: 0 22px;
}

.middle {
  display: flex;
  flex-wrap: wrap;
}

.row {
  display: flex;
  flex-direction: column;
  padding: 0 22px;
  width: 100%;
  margin-top: 15px;
}
.middles {
  display: flex;
  justify-content: center;
  margin-top: 10%;
}

.middles p {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.25);
  text-align: center;
}

.modular {
  height: calc((100vw - 476px) / 4 / 16 * 9);
  background: #ccc;
  border-radius: 5px;
}

.row span {
  cursor: pointer;
}
.modular img:hover {
  -webkit-box-shadow: #53a4f0 0px 0px 10px;
  -moz-box-shadow: #53a4f0 0px 0px 10px;
  box-shadow: #53a4f0 0px 0px 10px;
}

.modular img {
  cursor: pointer;
  width: 100%;
  height: 100%;
  /* object-fit: contain; */
  border: 1px solid #ccc;
  border-radius: 5px;
}

.fotter {
  float: right;
  padding: 20px 0;
}

.report-name {
  color: #333;
  font-size: 18px;
  font-weight: 700;
}
</style>
